import { stringify } from 'qs';

const homePageRoutes = {
  exclusiveListings(marketShapeSlug) {
    return `/api/homepage/${marketShapeSlug}/exclusive_listings`;
  },
};

export default {
  building: (buildingSlug: string) => `/api/buildings/${buildingSlug}`,
  buildingListings: (buildingSlug: string) => `/api/buildings/${buildingSlug}/listings`,
  buildingMapMarkers: buildingSlug => `/api/buildings/${buildingSlug}/map_markers`,
  buildingSave: buildingSlug => `/api/buildings/${buildingSlug}/saves`,
  buildings: '/api/buildings',
  buildingImagesZipUrl: (buildingSlug: string) => `/api/buildings/${buildingSlug}/images_zip_url`,
  currentUser: '/api/current_user',
  favoritedListings: '/api/favorited_listings',
  favorites: listingIds => `/api/favorites?${stringify({ listings: listingIds.join(',') })}`,
  globalSearches: query => `/api/global_searches?query=${query}`,
  inquiries: listingId => `/api/listings/${listingId}/inquiries`,
  landlord: landlordSlug => `/api/landlords/${landlordSlug}`,
  landlordImagesZipUrl: (landlordSlug: string) => `/api/landlords/${landlordSlug}/images_zip_url`,
  landlords: ({ marketSlug, query = '' }: { marketSlug: string; query: string }) =>
    `/api/markets/${marketSlug}/landlords?query=${query}`,
  buildingOwnerSave: landlordSlug => `/api/building_owners/${landlordSlug}/save`,
  landlordPortfolio: ({ landlordSlug, regionSlug }) =>
    `/api/landlords/${landlordSlug}/portfolios/${regionSlug}`,
  listing: listingId => `/api/listings/${listingId}`,
  listingFavorited: listingId => `/api/listings/${listingId}/favorites`,
  listingFavorites: listingId => `/api/listings/${listingId}/favorites`,
  listingShare: (encodedData: string) => `/api/listing_shares/${encodedData}`,
  listingShares: (listingId: string) => `/api/listings/${listingId}/shares`,
  listingImagesZipUrl: (listingId: string) => `/api/listings/${listingId}/images_zip_url`,
  listingSearchFilters: ({
    submarketSlugs,
    landlordsIds,
    buildingIds,
  }: {
    submarketSlugs;
    landlordsIds;
    buildingIds;
  }) =>
    // eslint-disable-next-line max-len
    `/api/listing_search_filters?submarketSlugs=${submarketSlugs}&landlords=${landlordsIds}&buildingIds=${buildingIds}`,
  listings: '/api/listings',
  marketSubmarkets: ({
    marketSlug,
    query,
    limit,
  }: {
    marketSlug: string;
    query: string;
    limit: number;
  }) => `/api/markets/${marketSlug}/submarkets?query=${query}&limit=${limit}`,
  marketBuildings: (marketSlug: string, query: string) =>
    `/api/markets/${marketSlug}/buildings?query=${query}`,
  markets: '/api/markets',
  savedSearchDescription: '/api/saved_search_description',
  savedSearches: '/api/saved_searches',
  savedBuildingOwners: '/api/saved_building_owners',
  savedSearch: (id: string) => `/api/saved_searches/${id}`,
  saveBuilding: () => `/api/saved_buildings`,
  submarkets: ({ longitude, latitude }: { longitude: number; latitude: number }) =>
    `/api/submarkets?longitude=${longitude}&latitude=${latitude}`,
  tourbooks: sort => `/api/tourbooks?sort=${sort}`,
  tourbook: (id: string) => `/api/tourbooks/${id}`,
  tourbookListings: (tourbookId: string) => `/api/tourbooks/${tourbookId}/listings`,
  tourbookListing: ({ tourbookId, listingId }: { tourbookId: string; listingId: string }) =>
    `/api/tourbooks/${tourbookId}/listings/${listingId}`,
  tourbookPowerpoint: (id: string) => `/api/tourbooks/${id}/powerpoint`,
  tourbookTourbookListing: ({
    tourbookId,
    tourbookListingId,
  }: {
    tourbookId: string;
    tourbookListingId: string;
  }) => `/api/tourbooks/${tourbookId}/tourbook_listings/${tourbookListingId}`,
  tourbookExternalListing: ({
    tourbookId,
    externalListingId,
  }: {
    tourbookId: string;
    externalListingId: string;
  }) => `/api/tourbooks/${tourbookId}/external_listings/${externalListingId}`,
  tourbookExternalListings: (tourbookId: string) =>
    `/api/tourbooks/${tourbookId}/external_listings`,
  homepage: homePageRoutes,
} as const;
